import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

type RowAction = {
  label: string;
  onClick: () => void;
};

type RowActionsMenuProps = {
  label: string;
  actions?: RowAction[];
  destructiveActions?: RowAction[];
};

function ActionList({ items, destructive = false }: { items: RowAction[]; destructive?: boolean }) {
  if (items.length === 0) return null;

  return (
    <div className="space-y-1">
      {items.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={item.onClick}
          className={
            destructive
              ? "block w-full rounded-md px-3 py-2 text-left text-sm text-destructive hover:bg-destructive/10"
              : "block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-muted"
          }
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export function RowActionsMenu({
  label,
  actions = [],
  destructiveActions = [],
}: RowActionsMenuProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" aria-label={label}>
          <MoreHorizontal size={16} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-44 rounded-md border border-border bg-card p-2 shadow-md"
      >
        <ActionList items={actions} />
        {actions.length > 0 && destructiveActions.length > 0 ? (
          <div className="my-2 h-px bg-border" />
        ) : null}
        <ActionList items={destructiveActions} destructive />
      </PopoverContent>
    </Popover>
  );
}
